import { connect, Dispatch } from 'react-redux';
import AbstractDriveItemListPage, { AbstractDriveItemListPageProps } from '../abstract';
import { StoreState } from '../../../reducers';
import { NewDriveItemsState } from '../../DriveItemList/New/reducer';
import { fetchNewDriveItems } from '../../DriveItemList/New/actions';

interface NewDriveItemListPageProps extends AbstractDriveItemListPageProps {
	dispatch: Dispatch<StoreState>;
	newDriveItems: NewDriveItemsState;
}

export class NewDriveItemListPage extends AbstractDriveItemListPage<NewDriveItemListPageProps> {

	headerLabel = 'messages.new';
	noItemsLabel = 'messages.no_new';
	showUnreadBadge = true;

	constructor(props: NewDriveItemListPageProps) {
		super(props);

		const { dispatch, newDriveItems } = props;
		const { isLoaded, isFetching } = newDriveItems;

		if (!isLoaded && !isFetching) {
			dispatch(fetchNewDriveItems());
		}
	}

	initializeView(props: NewDriveItemListPageProps): void {
		return;
	}

	getDriveItemIds(): number[] {
		const { newDriveItems } = this.props;
		const { isFetching, items } = newDriveItems;

		if (isFetching) {
			return [];
		}

		return Object.keys(items).map(key => parseInt(key, 10)).reverse();
	}

	isFetching(): boolean {
		return this.props.newDriveItems.isFetching;
	}
}

const mapStateToProps = (state: StoreState) => {
	const { newDriveItems } = state;
	return { newDriveItems };
};

export default connect(mapStateToProps)(NewDriveItemListPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemListPage/extends/New.tsx